import { FunctionComponent } from 'react'
import { HeroSVGProps } from '@/components/HeroIcons/icon-types'
import { useTheme } from '@emotion/react'

const MedicineFolder: FunctionComponent<HeroSVGProps> = ({
  themeColor,
  ...rest
}) => {
  const theme = useTheme()
  return (
    <svg
      {...rest}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.54167 3.20833C2.54167 1.71256 3.75423 0.5 5.25 0.5H10.3569C11.1857 0.5 11.9806 0.829241 12.5666 1.41529L14.543 3.39168C15.1291 3.97773 15.4583 4.77259 15.4583 5.60139V8.64468C15.4583 8.98986 15.1785 9.26968 14.8333 9.26968C14.4882 9.26968 14.2083 8.98986 14.2083 8.64468V5.60139C14.2083 5.10411 14.0108 4.6272 13.6592 4.27557L11.6828 2.29918C11.3311 1.94754 10.8542 1.75 10.3569 1.75H5.25C4.44458 1.75 3.79167 2.40292 3.79167 3.20833V6.14468C3.79167 6.48986 3.51184 6.76968 3.16667 6.76968C2.82149 6.76968 2.54167 6.48986 2.54167 6.14468V3.20833Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6667 0.519683C11.0118 0.519683 11.2917 0.799505 11.2917 1.14468V4.04167C11.2917 4.38685 11.5715 4.66667 11.9167 4.66667H14.8137C15.1589 4.66667 15.4387 4.94649 15.4387 5.29167C15.4387 5.63685 15.1589 5.91667 14.8137 5.91667H11.9167C10.8811 5.91667 10.0417 5.0772 10.0417 4.04167V1.14468C10.0417 0.799505 10.3215 0.519683 10.6667 0.519683Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.875 7.81135C0.875 6.5457 1.90101 5.51968 3.16667 5.51968H6.66407C7.291 5.51968 7.87645 5.83302 8.2242 6.35466C8.2242 6.35467 8.22419 6.35465 8.2242 6.35466L9.14867 7.74137C9.26459 7.91524 9.45973 8.01968 9.6687 8.01968H14.8333C16.099 8.01968 17.125 9.0457 17.125 10.3113V15.3114C17.125 16.577 16.099 17.603 14.8333 17.603H3.16667C1.90101 17.603 0.875 16.577 0.875 15.3114V7.81135ZM3.16667 6.76968C2.59137 6.76968 2.125 7.23605 2.125 7.81135V15.3114C2.125 15.8866 2.59137 16.353 3.16667 16.353H14.8333C15.4086 16.353 15.875 15.8866 15.875 15.3114V10.3113C15.875 9.73605 15.4086 9.26968 14.8333 9.26968H9.6687C9.04179 9.26968 8.45636 8.95637 8.10861 8.43475L7.18414 7.04804C7.06822 6.87415 6.87305 6.76968 6.66407 6.76968H3.16667Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 11.7697C4 11.4245 4.27982 11.1447 4.625 11.1447H7.125C7.47018 11.1447 7.75 11.4245 7.75 11.7697C7.75 12.1149 7.47018 12.3947 7.125 12.3947H4.625C4.27982 12.3947 4 12.1149 4 11.7697Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.875 9.89468C6.22018 9.89468 6.5 10.1745 6.5 10.5197V13.0197C6.5 13.3649 6.22018 13.6447 5.875 13.6447C5.52982 13.6447 5.25 13.3649 5.25 13.0197V10.5197C5.25 10.1745 5.52982 9.89468 5.875 9.89468Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
    </svg>
  )
}

export default MedicineFolder
